import React from 'react';
import Svg, { Path } from 'react-native-svg';

export const NovaNavigateIcon = () => (
  <Svg
    width="36"
    height="36"
    viewBox="0 0 36 36"
    fill="none"
  >
    <Path
      d="M0 4C0 1.79086 1.79086 0 4 0H32C34.2091 0 36 1.79086 36 4V32C36 34.2091 34.2091 36 32 36H4C1.79086 36 0 34.2091 0 32V4Z"
      fill="#2C7CD3"
      fillOpacity="0.1"
    />
    <Path
      d="M10.5 17.168L26.3333 9.66797L18.8333 25.5013L17.1667 18.8346L10.5 17.168Z"
      stroke="#2C7CD3"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Svg>
);
